<template>
  <div>
    <v-autocomplete
      :prepend-icon="icon ? icons.mdiAlphaCCircle : null"
      :clearable="clearable"
      hide-details="auto"
      :disabled="disabled"
      v-model="select"
      :items="lista"
      :label="label"
      item-value="id"
      item-text="numero_cuenta"
      :dense="outlined"
      :outlined="outlined"
      :loading="cargando"
      :append-outer-icon="add ? icons.mdiPlusCircleOutline : null"
      @click:append-outer="abrirModal()"
      :rules="rules"
      @change="change"
    >
      <template v-slot:no-data>
        <v-list-item>
          <v-list-item-title> No hay cuentas </v-list-item-title>
        </v-list-item>
      </template>
      <template v-slot:selection="{ item }">
        <span> {{ item.numero_cuenta }} </span> <small> {{ ' (' +item.banco.nombre }})</small>
      </template>
      <template v-slot:item="{ item }">
        <v-list-item-content>
          <v-list-item-title> {{ item.numero_cuenta }} </v-list-item-title>
        </v-list-item-content>
        <v-list-item-icon>
          <small>{{ item.banco.nombre }}</small>
        </v-list-item-icon>
      </template>
    </v-autocomplete>
  </div>
</template>
<script>
import { onBeforeMount, ref, watch } from '@vue/composition-api'
import { mdiAlphaCCircle, mdiPlusCircleOutline } from '@mdi/js'
import CuentasService from '@/api/servicios/CuentasService'
export default {
  components: {},
  props: {
    value: String,
    jsonRespueta: Boolean,
    disabled: Boolean,
    dense: Boolean,
    outlined: Boolean,
    icon: Boolean,
    todos: Boolean,
    default: Number,
    clearable: Boolean,
    padres: {
      type: Object,
      default: {},
    },
    rules: Array,
    add: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      default: 'Almacen',
    },
  },
  watch: {
    padres: function (news, old) {
      if (JSON.stringify(news) != JSON.stringify(old)) {
        this.cargarDatos()
      }
    },
  },
  setup(props, contex) {
    const lista = ref([])
    const select = ref(null)
    const cargando = ref(false)
    const dialog = ref(false)

    watch(props, () => {
      select.value = props.value
    })
    onBeforeMount(() => {
      cargarDatos()
      if (props.value != undefined) {
        select.value = props.value
      }
    })

    const GetActualizarLista = item => {
      lista.value.push(item)
      select.value = item.id
      dialog.value = false
    }
    const abrirModal = () => {
      dialog.value = true
    }
    const cargarDatos = () => {
      lista.value = []
      cargando.value = true
      console.log(props.padres)
      if (props.padres) {
        try {
          CuentasService.cuentaBancariaListar({ ...props.padres })
            .then(response => {
              console.log(response)
              if (response.data.mensaje == 'BUSQUEDA_EXITOSA') {
                lista.value = response.data.datos
              }
            })
            .catch(error => {
              console.log(error)
            })
            .finally(() => {
              cargando.value = false
            })
        } catch (error) {
          cargando.value = false
        }
      } else {
        cargando.value = false
      }
    }

    watch(select, () => {
      const valor = lista.value.find(item => item.id == select.value)

      if (props.jsonRespueta == true) {
        contex.emit('input', valor == undefined ? null : valor)
      } else contex.emit('input', select.value)
    })

    const change = () => {
      contex.emit('change')
    }

    return {
      icons: {
        mdiAlphaCCircle,
        mdiPlusCircleOutline,
      },
      lista,
      select,
      cargando,
      dialog,
      abrirModal,
      GetActualizarLista,
      cargarDatos,
      change,
    }
  },
}
</script>